import React from 'react';
import { Grid, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/reducers';

const StepThreeGridActionItems = ({ handleBack, handleSkip, processContractsPending, classes, handleOpenConfirmDialog }) => {

    const selectedItems: any = useSelector<RootState>(
        (state) => state?.pagesV2['pricer-config-contracts-landing']?.selected
    );

    return (
        <Grid className='pt-2 justify-content-end' container>
            <Button onClick={handleBack} variant="contained" className='mr-2'>
                Back
            </Button>
            <Button
                onClick={() => handleSkip(selectedItems)}
                variant="contained"
                className={`${classes.skipButton} mr-2`}
                disabled={processContractsPending}
            >
                Skip
            </Button>
            <Button
                onClick={handleOpenConfirmDialog}
                variant="contained"
                color="primary"
                disabled={processContractsPending}
            >
                Start
            </Button>
        </Grid>
    );
}

export default StepThreeGridActionItems;
